import { render, staticRenderFns } from "./LalamoveModal.vue?vue&type=template&id=0197a6f5&scoped=true"
import script from "./LalamoveModal.vue?vue&type=script&lang=js"
export * from "./LalamoveModal.vue?vue&type=script&lang=js"
import style0 from "./LalamoveModal.vue?vue&type=style&index=0&id=0197a6f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197a6f5",
  null
  
)

export default component.exports